export default __webpack_public_path__ + "assets/images/06a074b001c6b81bbb6ff62500537711.png";